module.exports = __webpack_public_path__ + "img/img7.4fce5670.png";